import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const GRID_COLUMNS = '81px 219px 139px 139px 181px 95px 110px';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding-top: 20px;
`;

const StyledHeader = styled.div`
	display: grid;
	grid-template-columns: ${GRID_COLUMNS};
	align-items: center;
	margin-bottom: 20px;
`;

const StyledHeaderCell = styled(Text)<{ $center?: boolean }>`
	font-weight: 500;
	font-size: 12px;
	color: #ffffff;
	opacity: 0.25;
	white-space: nowrap;
	text-align: ${(props) => (props.$center ? 'center' : 'left')};
	padding-left: ${(props) => (props.$center ? '0' : '20px')};
`;

const StyledList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledRow = styled.div`
	display: grid;
	grid-template-columns: ${GRID_COLUMNS};
	align-items: center;
	height: 60px;
	min-height: 60px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
`;

const StyledNumberCell = styled(Text)`
	padding-left: 20px;
	font-size: 14px;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledNameCell = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
`;

const StyledOnlineDot = styled.div`
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: #1ab248;
`;

const StyledPlayerName = styled(Text)`
	font-weight: 500;
	font-size: 14px;
	color: #ffffff;
	white-space: nowrap;
`;

const StyledIdentifierCell = styled(Text)`
	text-align: center;
	font-size: 14px;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledReasonCell = styled(Text)`
	text-align: center;
	font-size: 14px;
	color: #ffffff;
`;

const StyledTimeCell = styled(Text)`
	text-align: center;
	font-size: 14px;
	color: #ffffff;

	span {
		color: rgba(255, 255, 255, 0.5);
	}
`;

const StyledButtonCell = styled.div`
	display: flex;
	justify-content: center;
`;

const StyledButtonWrapper = styled.div`
	width: 80px;
`;

const StyledButtonText = styled(Text)`
	font-weight: 500;
`;

export {
	StyledButtonCell,
	StyledButtonText,
	StyledButtonWrapper,
	StyledContainer,
	StyledHeader,
	StyledHeaderCell,
	StyledIdentifierCell,
	StyledList,
	StyledNameCell,
	StyledNumberCell,
	StyledOnlineDot,
	StyledPlayerName,
	StyledReasonCell,
	StyledRow,
	StyledTimeCell,
};
